import { cart, pubsub } from '@services';
import { parseHTML } from '@utils';

class CartDrawerSummary extends HTMLElement {
  #unsubscribers = [];
  #buttons = this.querySelectorAll('.button');

  static {
    cart.sections.push('fetch-cart-drawer-summary');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        pubsub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      ),
      pubsub.subscribe('cart:fetch', ({ status }) => this.#handleLoading(status === 'pending'))
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-drawer-summary']);
    const target = html.querySelector('cart-drawer-summary');
    this.replaceWith(target);
  }

  #handleLoading(loading) {
    this.#buttons.forEach((button) => {
      button.classList.toggle('loading', loading);
    });
  }
}

customElements.define('cart-drawer-summary', CartDrawerSummary);
